import { environmentVars } from 'constants/services';
import { States } from 'constants/states';
import { GeoLocation } from 'records/GeoLocation';
import { ProjectLocation } from 'records/Project';

type Address = {
  street: string;
  zipcode: string;
  city: string;
  state: string;
};

const _bboxToBounds = (minMaxBounds: number[]): Bounds => {
  const [minX, minY, maxX, maxY] = minMaxBounds;
  return [
    [minX, minY],
    [maxX, maxY],
  ];
};

const geocode = async (address: Address): Promise<ProjectLocation | null> => {
  const { street, city, state, zipcode } = address;
  if (street || city || state || zipcode) {
    const uri = encodeURI(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${street} ${city} ${States[state]} ${zipcode}.json?access_token=${environmentVars.MAPBOX_API_KEY}`
    );
    const resp = await fetch(uri, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const json = await resp.json();

    if (json && json.features?.length > 0) {
      return {
        center: {
          longitude: json.features[0]?.center[0],
          latitude: json.features[0].center[1],
        },
        bounds: json.features[0].bbox
          ? _bboxToBounds(json.features[0].bbox)
          : [],
      };
    }
  }
  return null;
};

const searchGeolocation = async (
  searchString: string
): Promise<Array<GeoLocation> | null> => {
  if (searchString) {
    const uri = encodeURI(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${searchString}.json?access_token=${environmentVars.MAPBOX_API_KEY}`
    );
    const resp = await fetch(uri, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const json = await resp.json();
    if (json && json.features?.length > 0) {
      return json.features;
    }
  }
  return null;
};

export { geocode, searchGeolocation };
